import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class APDInsurance  {
    _originalTypeClassName = "zERP.BO.APDInsurance";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
APDInsurance.translate = translateService;
}
this.APDSubsidy = [];
this.Id = null;
this.RecordType = null;
this.AnnexNumber = null;
this.KAD = null;
this.FullTime = false;
this.AllWorking = false;
this.SundaysHolidaysWork = null;
this.SpecialtyCode = null;
this.SpecialInsuranceCases = null;
this.CoveragePackage = null;
this.PayPeriodMonth = null;
this.PayPeriodYear = null;
this.FromEmployment = null;
this.ToEmployment = null;
this.SalaryType = null;
this.InsuranceDays = null;
this.Wage = null;
this.Earnings = null;
this.InsuredContributions = null;
this.EmployerContributions = null;
this.TotalContributions = null;
this.TotalInsuredSubsidyAmount = null;
this.TotalEmployerSubsidyAmount = null;
this.ContributionsPayable = null;
this.TotalAmountSubsidies = null;
this.DiseaseAgencyNoeEFKA = null;
this.PromissorySalariedLawyers = null;
this.SupplementaryInsuranceNoeEFKA = null;
this.DailyWageEarner = false;
this.WeeklyWork = null;
this.CounterpartyStatus = null;
this.MainEarnings = null;
this.SumInsuredContributions = null;
this.SumEmployerContributions = null;
this.SumTotalContributions = null;
this.SumTotalInsuredSubsidyAmount = null;
this.SumTotalEmployerSubsidyAmount = null;
this.SumContributionsPayable = null;
this.SumTotalAmountSubsidies = null;
this.SumInsuranceDays = null;
this.EmptyFields = false;
this._key = this.Id = 0; 
}

static translate: TranslateService;
_key: any;
private _Id:any;
get Id(): any {
    return this._Id;
  }
set Id(value: any) {
    this._Id = value;
    this._key = value;
  }
RecordType:any;
AnnexNumber:any;
KAD:any;
FullTime:any;
AllWorking:any;
SundaysHolidaysWork:any;
SpecialtyCode:any;
SpecialInsuranceCases:any;
CoveragePackage:any;
PayPeriodMonth:any;
PayPeriodYear:any;
FromEmployment:any;
ToEmployment:any;
SalaryType:any;
InsuranceDays:any;
Wage:any;
Earnings:any;
InsuredContributions:any;
EmployerContributions:any;
TotalContributions:any;
TotalInsuredSubsidyAmount:any;
TotalEmployerSubsidyAmount:any;
ContributionsPayable:any;
TotalAmountSubsidies:any;
DiseaseAgencyNoeEFKA:any;
PromissorySalariedLawyers:any;
SupplementaryInsuranceNoeEFKA:any;
DailyWageEarner:any;
WeeklyWork:any;
CounterpartyStatus:any;
MainEarnings:any;
SumInsuredContributions:any;
SumEmployerContributions:any;
SumTotalContributions:any;
SumTotalInsuredSubsidyAmount:any;
SumTotalEmployerSubsidyAmount:any;
SumContributionsPayable:any;
SumTotalAmountSubsidies:any;
SumInsuranceDays:any;
EmptyFields:any;
APDSubsidy:any;
static setAPDSubsidy = ($this, items) => {
                if (items == null) items = [];
                if ($this.APDSubsidy == null) $this.APDSubsidy = [];

                const copyItems = Common.cloneObject(items);

                while ($this.APDSubsidy.length > 0) {
                    Domain.APDInsurance.removeAPDSubsidy($this, $this.APDSubsidy[0]);
                }

                Domain.APDInsurance.addManyAPDSubsidy($this, copyItems);
            }
static addManyAPDSubsidy = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.APDInsurance.addAPDSubsidy($this, items[i]);
                }
            }
static addAPDSubsidy = ($this, item) => {
                if ($this.APDSubsidy == null) $this.APDSubsidy = [];
                if (item == null || $this.APDSubsidy.indexOf(item) > -1) return;
                $this.APDSubsidy.push(item);
}
static addRangeAPDSubsidy = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.APDInsurance.addAPDSubsidy($this, item));
            }
static removeAPDSubsidy = ($this, item) => {
                if ($this == null || $this.APDSubsidy == null || $this.APDSubsidy.indexOf(item) === -1) return;
                var _index = $this.APDSubsidy.indexOf(item);
                $this.APDSubsidy.splice(_index, 1);
}
static clearAPDSubsidy = ($this) => { $this.APDSubsidy = null; }


static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.Id == null || $this.Id == 0;
            }


}